//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 import Pristine from 'pristinejs'; 
 
 export default{
     name: "getquote",
     props:{
         content: Object
     },
     data(){
         return {
           form_sent: false,
           doing_label: "I need a job doing at",
           help_label: "I need help with",
           help: null,
           doing: null,
           file_chosen: "",
           submitted: false,
           valid: true,
           pristine: null,
           pristineConfig: {
               classTo: 'input-group',
               errorClass: 'has-error',
               successClass: 'has-success',
               errorTextParent: 'input-error',
               errorTextTag: 'span',
               errorTextClass: 'text-help'
           }
         }
     },
     mounted(){
           this.pristine = new Pristine(this.$refs.form, this.pristineConfig);      
           this.$refs.form.action = process.env.PRODUCTION_BASE_URL + "/quote";     
           this.$refs.referrer = process.env.FRONTEND_PRODUCTION_BASE_URL + location.href.replace(location.origin,'');

           if (this.$route.hash == '#submitted'){
               this.submitted = true;
           }
     },
     methods:{
         changeHelp(){
             this.help_label = 'I need help with ' + this.help;
         },
         changeDoing(){
             this.doing_label = 'I need a job doing at ' + this.doing;
         },
         checkFiles(){
             let $files = this.$refs.photos.files;
             this.file_chosen = '(' + $files.length + ")";
         },
         submitForm(e){
           this.valid = this.pristine.validate(); 

           e.preventDefault();
           
           if (this.valid)
           { 
 
                   let $self = this;
                   let myForm = this.$refs.form;
                   this.form_sent = true;
                   myForm.submit(); 
           }
           else
           {
               console.log("invalid");
           }
         }
     }
}

